import { AuditType } from "@/api/dtos";

const mapping: Record<AuditType, string> = {
    [AuditType.Inserted]: 'Inserted',
    [AuditType.Updated]: 'Updated',
    [AuditType.Deleted]: 'Deleted'
};

const auditTypeToText = (type?: AuditType) => {
    if (!type) {
        return 'Unknown'
    }

    return mapping[type];
}

export default auditTypeToText;